var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('patient-profile',{attrs:{"title":"Edit Patient Profile","method":"edit","changed":_vm.changed},on:{"update:changed":function($event){_vm.changed=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }